<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>Political Perversion</h1>
<h1 class="bk1">Rhetorical Aberration in the Time of Trumpeteering</h1>
<p class="bkau">Joshua Gunn</p>
<p class="bkpub">The University of Chicago Press   C<span class="sm">HICAGO</span> <span class="sm">&amp;</span> L<span class="sm">ONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gunn-0004.vue?21f0336a